"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.offMessage = exports.onMessagePayload = exports.sendToCore = exports.sendToDevtoolsPrivate = exports.sendToBackgroundScript = exports.sendToContentScript = void 0;
const BridgeHelpers_1 = require("@ulixee/apps-chromealive-core/lib/BridgeHelpers");
const currentTabId = chrome.devtools.inspectedWindow.tabId;
const currentMessengerLocation = BridgeHelpers_1.MessageLocation.DevtoolsScript;
function sendToContentScript(tabId, payload, responseCallbackFn) {
    const message = {
        destLocation: BridgeHelpers_1.MessageLocation.ContentScript,
        origLocation: currentMessengerLocation,
        payload,
        ...convertResponseFnToCodeAndId(responseCallbackFn),
    };
    routeInternally(message);
}
exports.sendToContentScript = sendToContentScript;
function sendToBackgroundScript(payload, responseCallbackFn) {
    const message = {
        destLocation: BridgeHelpers_1.MessageLocation.BackgroundScript,
        origLocation: currentMessengerLocation,
        payload,
        ...convertResponseFnToCodeAndId(responseCallbackFn),
    };
    routeInternally(message);
}
exports.sendToBackgroundScript = sendToBackgroundScript;
function sendToDevtoolsPrivate(payload, responseCallbackFn) {
    const message = {
        destLocation: BridgeHelpers_1.MessageLocation.DevtoolsPrivate,
        origLocation: currentMessengerLocation,
        payload,
        ...convertResponseFnToCodeAndId(responseCallbackFn),
    };
    routeInternally(message);
}
exports.sendToDevtoolsPrivate = sendToDevtoolsPrivate;
function sendToCore(payload, responseCallbackFn) {
    const message = {
        destLocation: BridgeHelpers_1.MessageLocation.Core,
        origLocation: currentMessengerLocation,
        payload,
        ...convertResponseFnToCodeAndId(responseCallbackFn),
    };
    routeInternally(message);
}
exports.sendToCore = sendToCore;
// LISTEN TO MESSAGES //////////////////////////////////////////////////////////////////////////////
let onMessageFn;
function onMessagePayload(fn) {
    if (onMessageFn)
        throw new Error('onMessage has already been set');
    onMessageFn = fn;
}
exports.onMessagePayload = onMessagePayload;
function offMessage() {
    onMessageFn = undefined;
}
exports.offMessage = offMessage;
// INTERNAL VARIABLES //////////////////////////////////////////////////////////////////////////////
const pendingByResponseId = {};
// LISTENER TO <-> FROM BACKGROUND /////////////////////////////////////////////////////////////////
let activePort;
function connect() {
    try {
        if (activePort)
            return;
        if (!currentTabId || currentTabId === -1) {
            console.warn('No tab id to register for devtools');
            return;
        }
        const port = chrome.runtime.connect({ name: `${currentMessengerLocation}:${currentTabId}` });
        handleConnectedToBackgroundScript(port);
    }
    catch (err) {
        console.error('Error connecting to service worker', err);
        setTimeout(connect, 5e3);
    }
}
function disconnectPort(port) {
    console.log('DISCONNECTED from BackgroundScript');
    port.onMessage.removeListener(handleIncomingMessageFromBackgroundScript);
    if (port === activePort) {
        activePort = null;
        setTimeout(connect, 1e3);
    }
}
function handleConnectedToBackgroundScript(port) {
    if (activePort === port)
        return;
    if (activePort && activePort !== port) {
        try {
            activePort.disconnect();
        }
        catch (err) {
            /* no-op */
        }
    }
    activePort = port;
    activePort.onDisconnect.addListener(disconnectPort.bind(null, port));
    activePort.onMessage.addListener(handleIncomingMessageFromBackgroundScript);
}
function handleIncomingMessageFromBackgroundScript(message) {
    if (message.destLocation === currentMessengerLocation) {
        if ((0, BridgeHelpers_1.isResponseMessage)(message)) {
            handleIncomingLocalResponse(message);
        }
        else {
            handleIncomingLocalMessage(message);
        }
    }
    else {
        // pass it along
        routeInternally(message);
    }
}
connect();
// HELPERS //////////////////////////////////////////////////////////////////////////////////////////
function handleIncomingLocalMessage(message) {
    const needsResponse = (0, BridgeHelpers_1.messageExpectsResponse)(message);
    const responseFn = needsResponse ? response => routeResponseBack(message, response) : undefined;
    onMessageFn(message.payload, responseFn);
}
function handleIncomingLocalResponse(response) {
    const pending = pendingByResponseId[response.responseId];
    if (!pending) {
        throw new Error(`Incoming response (${response.responseId}) could not be handled`);
    }
    delete pendingByResponseId[response.responseId];
    clearTimeout(pending.timeoutId);
    pending.responseFn(response.payload);
}
function routeResponseBack(message, responsePayload) {
    const responseCode = BridgeHelpers_1.ResponseCode.R;
    const { responseId, origLocation: destLocation } = message;
    const response = {
        destLocation,
        origLocation: currentMessengerLocation,
        responseId,
        responseCode,
        payload: responsePayload,
    };
    routeInternally(response);
}
// INTERNAL ROUTING ////////////////////////////////////////////////////////////////////////////////
function routeInternally(message) {
    activePort.postMessage(message);
}
function convertResponseFnToCodeAndId(responseFn) {
    if (responseFn) {
        const responseId = (0, BridgeHelpers_1.createResponseId)();
        pendingByResponseId[responseId] = {
            responseFn,
            timeoutId: setTimeout(() => {
                throw new Error(`Response for ${responseId} not received within 10s`);
            }, 10e3),
        };
        return {
            responseCode: BridgeHelpers_1.ResponseCode.Y,
            responseId,
        };
    }
    return {
        responseCode: BridgeHelpers_1.ResponseCode.N,
    };
}
